module.exports = __webpack_public_path__ + "images/hikakaku-normal_639ad95f345dd156025debeb7f8f826e.png";